import { render, staticRenderFns } from "./OnboardingChooseForWhoPage.vue?vue&type=template&id=3dbc0ffc"
import script from "./OnboardingChooseForWhoPage.vue?vue&type=script&lang=ts"
export * from "./OnboardingChooseForWhoPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports